import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import RegistrationPage from "./pages/RegistrationPage";
import Homepage from "./pages/Home/Homepage";
import Loginpage from "./pages/Loginpage";
import Forgotpage from "./pages/Forgotpage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import OtpPage from "./pages/OtpPage";
import CartPage from "./pages/CartPage";
import Products from "./pages/Products";
import Header from "./componands/Header";
import Footer from "./componands/Footer";
import ProfilePage from "./pages/Profile/ProfilePage";
import AddressBook from "./pages/Profile/AddressBook.jsx";
import ProductDetails from "./pages/ProductDetails";
import PrivateRoute from "./componands/PrivateRoute";
import UploadPrescription from "./pages/Home/UploadPrescription.js";
import About from "./pages/Home/About.jsx";
import Payment from "./pages/Profile/MyPayment.jsx";
import CheckOut from "./pages/CheckOut.jsx";
import NotFoundPage from "./pages/NotFoundPage"; // Import the NotFoundPage component
import OrderTracking from "./pages/Home/OrderTracking.jsx";
import Buymedicines from "./pages/Home/Buymedicines.jsx";
import Loyaltyprogram from "./pages/Home/Loyaltyprogram.jsx";
import Search from "./pages/Home/Search.jsx";
import Offer from "./pages/Home/Offer.jsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Invoice from "./pages/Invoice.jsx";
import PrivacyPolicy from "./componands/PrivacyPolicy.js";
import Datadeletion from "./componands/Datadeletion.js";
import MetaTag from "./componands/MetaTag.js";

function App() {
  const location = useLocation();

  const hideHeaderFooter = [
    "/login",
    "/register",
    "/forgot",
    "/reset-password",
    "/otppage",
  ];

  return (
    <div>
      {!hideHeaderFooter.includes(location.pathname) && <Header />}
      <MetaTag />
      <Routes>
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/login" element={<Loginpage />} />
        <Route path="/forgot" element={<Forgotpage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/otppage" element={<OtpPage />} />
        <Route path="/cartpage" element={<CartPage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/productdetails/:id" element={<ProductDetails />} />
        <Route path="/" element={<Homepage />} />
        <Route path="/uploadprescription" element={<UploadPrescription />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/buymedicines" element={<Buymedicines />} />
        <Route path="/loyaltyprogram" element={<Loyaltyprogram />} />
        <Route path="/search" element={<Search />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/datadeletion" element={<Datadeletion />} />
        {/* Private Routes */}
        <Route
          path="/profile"
          element={<PrivateRoute element={<ProfilePage />} />}
        />
        <Route
          path="/ordertracking"
          element={<PrivateRoute element={<OrderTracking />} />}
        />
        <Route
          path="/checkout"
          element={<PrivateRoute element={<CheckOut />} />}
        />
        <Route
          path="/addressbook"
          element={<PrivateRoute element={<AddressBook />} />}
        />

        {/* 404 Page Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {!hideHeaderFooter.includes(location.pathname) && <Footer />}
    </div>
  );
}

function AppWithRouter() {
  // Move the clientId declaration here
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.error(
      "Google Client ID is missing. Please check your environment variables."
    );
    return <div>Error: Missing Client ID</div>;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Router>
        <App />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default AppWithRouter;
